import React from 'react';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { TextAreaFormField } from '../../components';

const SupportForm = ({ updateRequest, request }) => {
  return (
    <form id='support-form'>
      <TextAreaFormField {...{
        id: 'Request',
        onChange: (e) => updateRequest(e.target.value),
        value: request
      }} />
    </form>
  )
}

export default compose(
  withStateHandlers(
    {
      request: ''
    },
    {
      updateRequest: () => (request) => ({ request })
    }
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      const { request, handleUpdate } = this.props
      const formUpdated = request !== prevProps.request
      if (formUpdated) {
        handleUpdate({
          request
        })
      }
    }
  })
)(SupportForm);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/support-form.js